import { render } from "./complianceText.vue?vue&type=template&id=510fd55c&scoped=true"
import script from "./complianceText.vue?vue&type=script&lang=js"
export * from "./complianceText.vue?vue&type=script&lang=js"

import "./complianceText.vue?vue&type=style&index=0&id=510fd55c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510fd55c"]])

export default __exports__